<script>
import DialogPromiseFormMixin from '@/modules/fptai/mixins/DialogPromiseFormMixin'
import FciDialog from '@/components/FciDialog'

export default {
    name: 'DialogEditorMixin',
    extends: DialogPromiseFormMixin,
    components: { FciDialog },
    data () {
        return {
            item: null
        }
    },
    methods: {
        open (item) {
            this.show = true
            this.item = item
            this.onOpen(item)
            return new Promise((resolve, reject) => {
                this.promise = { resolve, reject }
            })
        },
        onOpen () {
        }
    }
}
</script>
